export default {
  addToCart: {
    en: 'Add to cart',
  },
  addToQueue: {
    en: 'Add to queue',
  },
}
